<template>
    <div class="form-group flex flex-col mb-6">
        <FormFieldLabel
            class="text-xs"
            :label-for="fieldName"
            :label="label"
            :required="required"
        />
        <TisInput
            v-if="type !== 'textarea'"
            :id="fieldName"
            v-model.trim="fieldValue"
            :name="fieldName"
            :type="type"
        />
        <TisTextarea
            v-if="type === 'textarea'"
            :id="fieldName"
            v-model.trim="fieldValue"
            ::name="fieldName"
            :type="type"
        />
        <FormFieldErrors
            v-if="hasErrors()"
            :errors="getError()" />
    </div>
</template>

<script>
import get from 'lodash/get';
import TisInput from '@whisper/components/forms/Primitives/TisInput';
import FormFieldErrors from '@whisper/components/forms/FormFieldErrors';
import FormFieldLabel from '@whisper/components/forms/FormFieldLabel';
import TisTextarea from '@whisper/components/forms/Primitives/TisTextarea';

export default {
  components: {
    TisTextarea,
    FormFieldLabel,
    FormFieldErrors,
    TisInput,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    required: {
      type: Boolean,
      default: false,
    },
    fieldName: {
      type: String,
      required: true,
    },
  },
  computed: {
    fieldValue: {
      set(value) {
        this.$emit('input', value);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    hasErrors() {
      return this.$page && this.$page.errors && this.$page.errors[this.fieldName];
    },
    getError() {
      return get(this, ['$page', 'errors', this.fieldName]);
    },
  },
};
</script>
